import { JepMapProperties } from '@jeppesen-foreflight/jmkw-types';
import { defaultBasemap } from './map-view/views/free.basemaps';

export const DEFAULT_MAP_PROPERTIES: JepMapProperties = {
  ground: 'world-elevation',
  // ground: 'world-topobathymetry',
  basemap: defaultBasemap
};
